import { useEffect, useState } from 'react';

declare global {
  interface Window {
    GetTelemetryID?: () => Promise<string>;
  }
}

export default function useTelemetryId() {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const existingTelemetryScript = document.getElementById(
      'stytchTelemetryAPI',
    );
    if (existingTelemetryScript) {
      setScriptLoaded(true);
      return;
    }

    const telemetryScript = document.createElement('script');

    telemetryScript.src = 'https://elements.stytch.com/telemetry.js';
    telemetryScript.id = 'stytchTelemetryAPI';
    telemetryScript.async = true;
    telemetryScript.onload = () => {
      setScriptLoaded(true);
    };

    const head = document.getElementsByTagName('head')[0];
    const firstScript = head.getElementsByTagName('script')[0];
    head.insertBefore(telemetryScript, firstScript);
  }, []);

  async function getTelemetryId(): Promise<string> {
    if (!scriptLoaded) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(getTelemetryId());
        }, 100);
      });
    }

    if (!window.GetTelemetryID) {
      throw new Error('Telemetry script not correctly initialized');
    }

    return await window.GetTelemetryID();
  }

  return { getTelemetryId };
}
